// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 874) return "static/chunks/874-e7fdbaf82ac68004.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"125":"59563f21e84c568a","450":"9d260f4b75590535","713":"7e3edf972b1fb3de","857":"b4d027b8623b15dd"}[chunkId] + ".js";
};